module.exports = __webpack_public_path__ + "img/staff.0a48c81c.webp";